const userApi = "http://localhost:1000/user";
export { userApi };
